import React from "react";
import { Switch, Redirect } from "react-router-dom";
import TopMenu from "Components/TopMenu/TopMenu";
import { superPricingMenuItems } from "Constants/superPricingMenuItems";
import SuperRoute from "hoc/Routes/SuperRoute/SuperRoute";
import Factors from "./components/Factors/Factors";
import Periods from "./components/Periods/Periods";
import Products from "./components/Products/Products";
import Services from "./components/Services/Services";
import SupervisorUser from "./components/SupervisorUser/SupervisorUser";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { read } from "Helpers/LocalStorage";

export default function PricingIndex() {
  const { isLoggedIn } = useSelector((state) => ({
    isLoggedIn: state.auth.isLoggedIn,
  }));
  let topMenuItems = [...superPricingMenuItems];
  topMenuItems.map((item) => {
    if (item.menu_title === "periods") {
      item.active = read("FormPeriod");
      return null;
    }
    if (item.menu_title === "factors") {
      item.active = true;
      return null;
    }
    if (item.menu_title === "products") {
      item.active = true;
      return null;
    }
    if (item.menu_title === "services") {
      item.active = true;
      return null;
    }
    if (item.menu_title === "supervisor") {
      item.active = true;
      return null;
    }
  });

  return (
    <>
      <TopMenu menuItems={topMenuItems.filter((item) => item.active)} />
      <Switch>
        <Redirect exact from="/admin/pricing" to="/admin/pricing/supervisor" />
        <SuperRoute
          exact
          path="/admin/pricing/factors"
          component={Factors}
          isLoggedIn={isLoggedIn}
        />
        <SuperRoute
          exact
          path="/admin/pricing/periods"
          component={Periods}
          isLoggedIn={isLoggedIn}
        />
        <SuperRoute
          exact
          path="/admin/pricing/products"
          component={Products}
          isLoggedIn={isLoggedIn}
        />
        <SuperRoute
          exact
          path="/admin/pricing/services"
          component={Services}
          isLoggedIn={isLoggedIn}
        />
        <SuperRoute
          exact
          path="/admin/pricing/supervisor"
          component={SupervisorUser}
          isLoggedIn={isLoggedIn}
        />
      </Switch>
    </>
  );
}
